<template>
    <div>
        <report-header
            ref="reportHeader"
            :child="child"
            :group="group"
            :step="step"
            :selected-all="false"
            :total-children-count="totalChildrenCount"
            :selected-children-count="selectedChildrenIds.length"
            :report-type="formTypeComponentData"
            v-on:select-all="selectAllChildren($event)"
            v-on="$listeners"/>

        <select-report-type
            :child="child ?? false"
            v-if="step === 1"
            v-on:report-type-selected="selectReportType($event)"
            v-on:close="close"/>

        <div class="pb-4 mb-5">
            <select-children
                v-if="step === 2 && selectedClass"
                :group="selectedClass"
                :selected-children-ids="selectedChildrenIds"
                ref="selectChildren"
                v-on:selected-children-ids="setSelectedChildrenIds($event)"
                v-on:children-count="childrenCount($event)"/>

            <daily-report-form
                v-if="step === 3 && formTypeComponentData"
                ref="dailyReportForm"
                :data="formTypeComponentData"
                :children-ids="childrenIds"
                :class-id="selectedClass?.id ?? child?.group_id"
                v-on:submit="submit($event)"/>
        </div>

        <report-footer
            v-on:change-step="changeStep($event)"
            :step="step"
            :prevDisabled="submitting"
            :nextDisabled="submitting || step === 2 && selectedChildrenIds.length === 0"/>
    </div>
</template>

<script>
import ReportFooter from "../molecules/ReportFooter.vue";
import SelectReportType from "./SelectReportType.vue";
import ReportHeader from "../molecules/ReportHeader.vue";
import SelectChildren from "../molecules/SelectChildren.vue";
import DailyReportForm from "./DailyReportForm.vue";
import {eventBus} from "../../../services/EventBus";
import {REPORT_TYPE} from "../../../services/Defaults";

export default {
    name: "DailyReportSteps",
    components: {DailyReportForm, SelectChildren, ReportHeader, SelectReportType, ReportFooter},
    props: {
        child: {
            type: Object,
            required: false
        },
        group: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            selectedClass: this.group,
            step: 1,
            totalChildrenCount: 0,
            selectedChildrenIds: [],
            formTypeComponentData: null,
            submitting: false,
        };
    },
    computed: {
        childrenIds() {
            return (this.child?.id !== undefined) ? [this.child.id] : this.selectedChildrenIds;
        }
    },
    watch: {
        child: function (data) {
            this.selectedChildrenIds = data ? [data.id] : [];
        },
        group: function (data) {
            this.selectedClass = data;
        },
    },
    methods: {
        init() {
            const selectedGroup = localStorage.getItem('selectedClass');
            if(selectedGroup) {
                this.selectedClass = JSON.parse(selectedGroup);
            }

            this.open();
        },
        setSelectedChildrenIds(childrenIds) {
            this.selectedChildrenIds = childrenIds;
        },
        childrenCount(count) {
            this.totalChildrenCount = count;
        },
        changeStep(direction) {
            const isForward = direction !== 'back';

            if (this.step === 3 && isForward) {
                this.submitting = true;
                this.$refs.dailyReportForm.submit();
            } else {
                const stepChange = (this.step === 1 || this.step === 3) && this.child ? 2 : 1;
                this.step += isForward ? stepChange : -stepChange;
            }
        },
        close() {
            this.$emit('close');
        },
        reset() {
            this.step = 1;
            this.selectedClass = null;
        },
        selectReportType(reportType) {
            if(reportType.value === REPORT_TYPE.DEVELOPMENT) {
                this.$emit('close');
                eventBus.$emit('openObserveChildren', this.child);
                return;
            }
            this.changeStep('next');
            this.formTypeComponentData = reportType;
        },
        selectAllChildren(state) {
            this.$refs.selectChildren.selectAll(state);
        },
        submit(status) {
            if (status.status === 'success') {
                this.$emit('reload', status.data);
                this.$emit('close');
            }
            this.submitting = false;
        }
    },
}
</script>
